module.exports = __webpack_public_path__ + "img/Balkon08.7f8317c8.webp";